var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Space, Typography } from 'antd';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { selectLoading, selectTeams, useContactStore } from 'stores/nic/stores/contactStore';
import { Button } from 'ui/styled';
import { RollbackOutlined } from '@ant-design/icons';
import { BaseDirectoryList } from './BaseDirectoryList';
import { AgentList } from './AgentList';
var Text = Typography.Text;
export var TeamList = function (_a) {
    var setAgentToCall = _a.setAgentToCall;
    var teams = useContactStore(selectTeams);
    var loading = useContactStore(selectLoading);
    var _b = useState([]), teamAgents = _b[0], setTeamAgents = _b[1];
    var teamItems = useMemo(function () {
        return teams.map(function (team) {
            var _a;
            return ({
                id: ((_a = team.teamId) === null || _a === void 0 ? void 0 : _a.toString()) || '',
                name: team.teamName || 'Unknown Team',
                status: team.isActive ? 'Active' : 'Inactive',
                description: "Members: ".concat(team.agentCount || 0),
                isAvailable: team.isActive,
                additionalInfo: {
                    agentCount: team.agentCount
                }
            });
        });
    }, [teams]);
    var openTeam = function (teamTest) { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, CXoneClient.instance.directory.teamService.getTeamDetailsById(teamTest === null || teamTest === void 0 ? void 0 : teamTest.id.toString())];
                case 1:
                    result = _a.sent();
                    if ('errorType' in result) {
                        throw new Error("Failed: ".concat(result.errorType, " - ").concat(result.message));
                    }
                    setTeamAgents(result === null || result === void 0 ? void 0 : result.agents);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.log('Team not found:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var renderTeamDescription = function (item) {
        var _a;
        return (_jsxs(Space, { orientation: "vertical", size: "small", onClick: function () { return openTeam(item); }, children: [_jsxs(Text, { type: "secondary", children: ["Status: ", item.status] }), _jsx(Text, { type: "secondary", style: { fontSize: '12px' }, children: item.description }), ((_a = item.additionalInfo) === null || _a === void 0 ? void 0 : _a.teamLead) && (_jsxs(Text, { type: "secondary", style: { fontSize: '12px' }, children: ["Lead: ", item.additionalInfo.teamLead] })), _jsxs(Text, { type: "secondary", style: { fontSize: '12px' }, children: ["ID: ", item.id] })] }));
    };
    return (teamAgents === null || teamAgents === void 0 ? void 0 : teamAgents.length) ? (_jsxs(_Fragment, { children: [_jsx("div", { style: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    padding: 8,
                    marginBottom: 8
                }, children: _jsx(Button, { onClick: function () { return setTeamAgents([]); }, icon: _jsx(RollbackOutlined, {}), children: "Back" }) }), _jsx(AgentList, { agents: teamAgents, setAgentToCall: setAgentToCall })] })) : (_jsx(BaseDirectoryList, { items: teamItems, loading: loading, renderDescription: renderTeamDescription, onItemAction: openTeam, emptyText: "Teams not found" }));
};
